import Password from "../components/password/Password";
export default function PasswordView(){
  return(
    <Password/>
  )
}